import UsersList from "../component/UsersList";
import React from "react";

const UsersListContainer = () => (<UsersList />)

export default UsersListContainer;